import { useSelector } from 'react-redux';

export default function PermissionRestrict({ roles = [], children, fallback }) {
  const userData = useSelector((state) => state.user.userData);
  return roles.includes(userData.userType) ? <>{children}</> : <>{fallback}</>;
}
